<div class="modal-header">
    <h4 class="modal-title">{{title ?? 'Upload File'}}</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
</div>

<div class="modal-body">
    <input id="file-input" type="file" accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.mp4,.mkv,.webm,.flv" (change)="handleFileInput($event.target.files)" />
    @if (disableSubmit) {
    <p class="fw-bold text-danger">Uploading file, please wait patiently...</p>
    }
    <p class="fw-bold">MAX FILE SIZE: 50 MB</p>
    <div class="modal-footer">
        <button class="btn btn-outline-success" type="button" (click)="addFile()" [disabled]="disableSubmit">Add File</button>
        <button class="btn btn-outline-danger" type="button" (click)="reset()">Cancel</button>
    </div>
</div>